import { useMemo } from "react";

export const useProfileResourcesPreviewCard = ({ message }) => {
    /**
     * Constants
     */

    const { elements, payload } = message || {};
    const { theme } = payload || {};
    const brandMarkUrl = payload?.images?.brandMark;

    /**
     * useMemo
     */

    const isSponsored = payload?.isSponsored;
    const buttonStyle = useMemo(
        () => ({
            backgroundColor: theme?.buttonBackgroundColor,
            color: theme?.buttonTextColor,
        }),
        [theme]
    );
    const cardStyle = useMemo(
        () => ({
            backgroundColor: theme?.backgroundColor,
            color: theme?.textColor,
        }),
        [theme]
    );
    const primaryButton = useMemo(() => elements?.buttons?.[0], [elements]);

    const isClaimLetterAction = useMemo(() => {
        const buttons = elements?.buttons || [];
        return buttons.some((button) =>
            button?.action?.type?.startsWith("action://free-letter/")
        );
    }, [elements]);

    /**
     * End Hooks & Constants
     */

    return {
        brandMarkUrl,
        buttonStyle,
        cardStyle,
        elements,
        isClaimLetterAction,
        isSponsored,
        primaryButton,
    };
};
